var _defs, _g, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.77 8.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #575756;\n      }\n\n      .cls-2 {\n        fill: #fc0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.44,7.75h-.56v-1.13h.56v1.13Zm-2.11-2.25v3.2c0,.09.09.19.18.19h3.29c.09,0,.18-.09.18-.19v-3.2h-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.66,8.69V3.52s2.11,1.41,2.11,1.41v.56h-.56v.56h.56v1.13h-.56v1.51c0,.09-.09.19-.18.19h-1.18c-.09,0-.18-.09-.18-.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.1,3.14l-1.55-1.03v2.47s0,0,0,0v3.17s0,0,0,0v.94c0,.09.09.19.18.19h1.18c.09,0,.18-.09.18-.19V3.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.77,8.69c0,.09-.09.18-.18.18H.18c-.09,0-.18-.09-.18-.19v-3.2h1.55v2.26h.56v-2.26h1.55v2.26h.56v-2.26h1.55v3.2Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.99 4.93 9.99 1.74 7.39 0 0 4.93 9.99 4.93"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1e7264e7c932749bd839edae79e71291.svg";
export { ForwardRef as ReactComponent };